import { createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../shared/gql-client";
import { GraphQLReadResponse } from "../../../general/domain/models/graphql";
import { GET_QR_FIELD_OPTIONS } from "../queries/RelationQueries";
import { gql } from "@apollo/client";
import { UserModel } from "../../../user/domain/models/userModel";

export const getQrFieldOptions = createAsyncThunk(
  "qrFieldOptions",
  async (_, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    try {
      return (await client.query(
        "qrFieldOptions",
        GET_QR_FIELD_OPTIONS,
      )) as GraphQLReadResponse;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const connectUserRelation = createAsyncThunk(
  "connectUserRelation",
  async (props: { userId: number; relationId: number }, thunkAPI) => {
    const { userId, relationId } = props;
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      return (await client.mutate(
        "connectUserRelation",
        gql(`
                    mutation connectUserRelation {
                        connectUserRelation(user_id: "${userId}", relation_id: "${relationId}") {
                            id
                        }
                    }
                `),
      )) as UserModel;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
